import React, { useState, useCallback, useEffect, useRef } from 'react';
import './Home.css';
import Header from '../Components/Layout/Header';
import Hero from '../Aseets/Img/Hero_Image.jpg';
import Frame from '../Aseets/Img/jelewry frame.png';
import Preloader from '../Components/Comman/Preloader';
import Footer from '../Components/Layout/Footer';
import Cards from '../Components/Comman/Card';
import Earrning from '../Aseets/Img/Earring.png';
import Necklace from '../Aseets/Img/Necklace.png';
import Gem from '../Aseets/Img/Necklace_gem.png';
import Ring from '../Aseets/Img/Ring.png';
import Button from '../Components/Comman/Button';
import valu from '../Aseets/Img/vaLU.svg';
import Egyptair from '../Aseets/Img/egypt air.svg';
import Egyptbank from '../Aseets/Img/egypt bank.svg';
import Card2 from '../Components/Comman/Card2';
import Logo1 from '../Aseets/Img/Logo1.png';
import Hands from '../Aseets/Img/hands.svg';
import FQA_cards from '../Components/Comman/FQA';
import Earring2 from '../Aseets/Img/Earing2.png';
import Earring3 from '../Aseets/Img/Earing3.png';
import Earring4 from '../Aseets/Img/Earing4.png';
import ImageSlider from '../Components/Comman/Image_slider';

const stats = [
  { target: 150, suffix: '+', label: 'Exhibitors' },
  { target: 10, suffix: 'K', label: 'Visitors' },
  { target: 8, suffix: 'th', label: 'Year' },
];

const frames = [Frame, Earring2, Earring3, Earring4];

const useCounter = (target, duration = 500, started) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!started) return;
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }, [started, target, duration]);

  return count;
};

const StatItem = ({ stat, started, index }) => {
  const count = useCounter(stat.target, 500 + index * 80, started);
  return (
    <div className="div2-section2">
      <h6 className="h6-section2-numbers">{count}{stat.suffix}</h6>
      <h6 className="h6-section2">{stat.label}</h6>
    </div>
  );
};

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [started, setStarted] = useState(false);
  const [frameIndex, setFrameIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    clearInterval(intervalRef.current);

    if (!isHovered) {
      intervalRef.current = setInterval(() => {
        setFrameIndex(prev => (prev + 1) % frames.length);
      }, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [isHovered]);

  const handleMouseEnter = useCallback(() => {
    if (!started) setStarted(true);
  }, [started]);

  return (
    <>
      {/* ✅ PRELOADER ADDED ONLY HERE */}
      {loading && <Preloader onFinish={() => setLoading(false)} />}

      {!loading && (
        <>
          <Header />

          <main>
            <section className='hero'>
              <div className='hero__inner'>
                <img className='hero__bg' src={Hero} alt="" />
                <img
                  className='hero__frame'
                  src={frames[frameIndex]}
                  alt=""
                  style={{
                    transform: isHovered ? 'scale(1.15)' : 'scale(1)',
                    transition: 'transform 0.4s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    setIsHovered(true);
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    setIsHovered(false);
                  }}
                />
              </div>
            </section>

            <section className='section2' onMouseEnter={handleMouseEnter}>
              <h4 className='h4-section2'>About the Exhibition</h4>
              <h1 className='h1-section2'>Egypt's Premier<br />Gold & Jewelry Expo</h1>
              <h5 className='h5-section2'>
                NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.
              </h5>
              <h5 className='h5-section2'>
                From handcrafted Pharaonic-inspired pieces to contemporary haute joaillerie, each exhibitor represents centuries of Egyptian craft heritage elevated to modern excellence.
              </h5>

              <div className='div1-section2'>
                {stats.map((stat, i) => (
                  <StatItem key={stat.label} stat={stat} started={started} index={i} />
                ))}
              </div>
            </section>

            <section className='section3'>
              <div className='text_section3'>
                <h4 className='h1-section2'>Exhibition Highlights</h4>
              </div>

              <div className='cards-container'>
                <Cards image={Earrning} title={<>Gold<br />Jewelry</>} />
                <Cards image={Ring} title={<>Precious<br />Stones</>} />
                <Cards image={Necklace} title={<>Antique<br />Collections</>} />
                <Cards image={Gem} title={<>Customizable<br />Jewelry</>} />
              </div>
            </section>

            <section className='section4'>
              <div className='section4_div1'>
                <h4 className='section4_text1'>The NEBU Process</h4>
                <h1 className='section4_text2'>Where Ideas <br />Come to Life</h1>
                <h4 className='section4_text1'>
                  Drag to reveal the journey from concept<br />sketch to golden reality
                </h4>
                <Button text="Explore more" />
              </div>

              <ImageSlider />
            </section>

            <div className='slider_image'>
              <div className='slider_track'>
                <img src={valu} alt="Valu" />
                <img src={Egyptair} alt="Egypt Air" />
                <img src={Egyptbank} alt="Egypt Bank" />
                <img src={valu} alt="Valu" />
                <img src={Egyptair} alt="Egypt Air" />
                <img src={Egyptbank} alt="Egypt Bank" />
                <img src={valu} alt="Valu" />
                <img src={Egyptair} alt="Egypt Air" />
                <img src={Egyptbank} alt="Egypt Bank" />
                <img src={valu} alt="Valu" />
                <img src={Egyptair} alt="Egypt Air" />
                <img src={Egyptbank} alt="Egypt Bank" />
              </div>
            </div>

            <section className='section6'>
              <div className='section6_div1'>
                <h4 className='h1-section2'>Exhibitors</h4>
                <Button text="See more" />
              </div>

              <div className='section6_div2'>
                <Card2 image={Logo1} title="Egypt Gold" />
                <Card2 image={Logo1} title="Egypt Gold" />
                <Card2 image={Logo1} title="Egypt Gold" />
                <Card2 image={Logo1} title="Egypt Gold" />
              </div>
            </section>

            <section className='section7'>
              <div className='section7_bg'>
                <div className='section7_img_wrapper'>
                  <img className='section7_svg' src={Hands} alt="Hands" />
                  <div className='section7_glow'></div>
                </div>

                <div className='section7_div1'>
                  <div className='section7_div2'>
                    <h3 className='section7_text1'>Answers</h3>

                    <div className='section7_div3'>
                      <div className='section7_line'></div>
                      <FQA_cards
                        title="What is Nebu ?"
                        text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}
                      />

                      <div className='section7_line'></div>
                      <FQA_cards
                        title="What is Nebu ?"
                        text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}
                      />

                      <div className='section7_line'></div>
                      <FQA_cards
                        title="What is Nebu ?"
                        text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}
                      />

                      <div className='section7_line'></div>
                      <FQA_cards
                        title="What is Nebu ?"
                        text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </main>

          <Footer />
        </>
      )}
    </>
  );
};

export default Home;